import label from './treemap.data.emphasis.label'
import upperLabel from './treemap.data.emphasis.upperLabel'
import itemStyle from './treemap.data.emphasis.itemStyle'

export default {
  name: "emphasis",
  nickname: "高亮",
  desc: "emphasis",
  type: "object",
  props: {
    label,
    upperLabel,
    itemStyle,
  },
}
